/* eslint-disable jsx-a11y/img-redundant-alt */
import React, { useEffect, useState } from 'react';
import './referal.css';
import TextField from '@mui/material/TextField';
import { Button } from '@mui/material';
// import { Stack } from '@mui/system';
import axios from 'axios';
import { useParams } from 'react-router-dom';
import { GrLocation } from 'react-icons/gr';
import { AiOutlinePhone } from 'react-icons/ai';
import ThankSinglePage from './ThankSinglePage';
import mayur from '../../assests/mayur.png';
import Loader from '../Loader';

const fieldSx = {
  '& .MuiOutlinedInput-root': { borderRadius: '12px', backgroundColor: '#fff' },
  '& .MuiOutlinedInput-input': { py: 1.5 },
};

function SingleReferral({ baseURL }) {
  const [data, setData] = useState(null);
  const [fullName, setFullName] = useState('');
  const [phoneNumber, setPhoneNumber] = useState('');
  const [email, setEmail] = useState('');
  const [pagechange,setPageChange] = useState(1);
  const [newContactId, setNewContactId] = useState();
  const [errorMessage, setErrorMessage] = useState('');
  const { linkid, templateid, contactid } = useParams();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    getReferralData();
  },[]);
    
  const getReferralData = async () => {
    setLoading(true);
    try {
      const response = await axios.get(`${baseURL}/testing/r/${linkid}?template_id=${templateid}&id=4`,{
        headers: {
          'Cache-Control': 'no-cache',
          Pragma: 'no-cache',
          Expires: '0',         
        },
      });
      console.log(response, 'getReferralData res');
      if (response.data.status === 'success') {
        setData(response?.data?.data);
        setLoading(false);
      }
    } catch (err) {
      console.log(err, 'getReferralData res');
    }    
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const formData = {
      first_name: fullName,
      phone: `${phoneNumber}`,
      email,
    };
    try {
      const response = await axios.put(`${baseURL}/testing/r/${linkid}?template_id=${templateid}&id=4`, formData);
      console.log(response, 'handleSubmit res');
      if (response.data.status === 'success') {
        setNewContactId(response?.data?.data?.lead_contact_id);
        setPageChange(pagechange + 1);
      }
      if (response.data.status === 'failure') {
        setErrorMessage(response.data.message);
        setError(response.data.error);
      }
    } catch (err) {
      console.log(err, 'handleSubmit res');
    }   
  };

  if (loading) {
    return <Loader />;
  }

  return (
    <div>
      {pagechange === 1 && (
        <div className="qs-page">
          <div className="qs-card">
            <div className="qs-card-body">
              <div className="space-y-2">
                <div className="text-lg font-semibold tracking-tight text-slate-900">{data?.name}</div>
                {data?.full_address !== null && (
                <div className="flex items-start gap-2 text-sm text-slate-500">
                  <span className="mt-0.5 shrink-0 opacity-70"><GrLocation /></span>
                  <span>
                    {data?.full_address}
                  </span>            
                </div>
                )}
                  
                {data?.phone !== null && (
                <div className="flex items-center gap-2 text-sm text-slate-500">
                  <span className="shrink-0 opacity-70"><AiOutlinePhone /></span>
                  <span>
                    {data?.phone}
                  </span>            
                </div>
                )}   
              </div>

              <div className="mt-6 flex justify-center">
                <figure>
                  {data?.referral_image?.length > 0 && (
                  <img src={data.referral_image} alt="logo" className="w-[250px] max-w-full rounded-2xl shadow-md ring-1 ring-black/5" />
                  )}                
                </figure>
              </div>
              <div className="mt-6 w-full">
                <div>
                  <h1 className="qs-title">{data?.heading}</h1>
                  <div className="qs-subtitle mt-2">
                    {data?.body}
                  </div>
                  <div className="mt-6 flex flex-col space-y-4">
                    <TextField
                      type="text"
                      size="small"
                      fullWidth
                      value={fullName}
                      onChange={(e) => setFullName(e.target.value)}
                      variant="outlined"
                      placeholder="Full name"
                      sx={fieldSx}
                    />
                    <TextField
                      type="number"
                      size="small"
                      value={phoneNumber}
                      onChange={(e) => setPhoneNumber(e.target.value)}
                      variant="outlined"
                      placeholder="Phone number"
                      sx={fieldSx}
                    />
                    <TextField
                      type="email"
                      size="small"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      variant="outlined"
                      placeholder="Email"
                      sx={fieldSx}
                    />
                    <div className="text-sm text-red-600">
                      <div>{error}</div>
                      <div>                    
                        {' '}
                        {errorMessage}
                      </div>
                    </div>
                    <Button 
                      disabled={fullName?.length < 2
                         || (phoneNumber?.length < 9 && email?.length < 5)}
                      variant="contained"
                      onClick={handleSubmit}
                      sx={{
                        borderRadius: '12px',
                        textTransform: 'none',
                        fontSize: '16px',
                        fontWeight: 500,
                        py: 1.5,
                        boxShadow: 'none',
                        '&:hover': { boxShadow: '0 6px 16px -6px rgba(37, 99, 235, 0.55)' },
                      }}
                    >
                      {data?.template?.submit_button_referral_from_text || 'Send'}
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {
          pagechange === 2 && (
          <ThankSinglePage
            data={data} 
            fullName={fullName}
            baseURL={baseURL}
            linkid={linkid}
            contactid={contactid}
            newContactId={newContactId}
          />
          )
      }

    </div>
    
  );
}

export default SingleReferral;
